import { STORAGE_KEYS } from '../constants/storage';
import { storeLocalValue, restoreLocalValue } from '../helpers/storage';

export const initFingerprint = async () => {
  if (typeof window === 'undefined') return;
  if (restoreLocalValue(STORAGE_KEYS.fingerprint)) return;
  try {
    const FingerprintJS = (await import('@fingerprintjs/fingerprintjs')).default;
    const fp = await FingerprintJS.load();
    const result = await fp.get({ excludes: { screenFrame: true } });
    storeLocalValue(STORAGE_KEYS.fingerprint, result.visitorId);
  } catch (e) {
    // fingerprint unavailable — skip silently
  }
};
